"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLatestImportantReading = exports.getLatestActualOrIndustryEstimateReading = exports.getLatestSmartReading = exports.getLatestActualReading = void 0;
var reads_config_1 = require("./reads-config");
var utils_1 = require("./utils");
var getLatestActualReading = function (readings) {
    var readsToValidateAgainst = readings.filter(function (reading) { return (0, utils_1.getReadingTypeLabel)(reading.readingType) !== 'Estimated'; });
    return readsToValidateAgainst.sort(utils_1.mostRecentFirst)[0];
};
exports.getLatestActualReading = getLatestActualReading;
var getLatestSmartReading = function (readings) {
    var readsToValidateAgainst = readings.filter(function (reading) { return (0, utils_1.getReadingTypeLabel)(reading.readingType) === 'Smart'; });
    return readsToValidateAgainst.sort(utils_1.mostRecentFirst)[0];
};
exports.getLatestSmartReading = getLatestSmartReading;
var getLatestActualOrIndustryEstimateReading = function (readings) {
    var readsToValidateAgainst = readings.filter(function (reading) {
        return (0, utils_1.getReadingTypeLabel)(reading.readingType) !== 'Estimated' ||
            reading.readingType === 'OpeningReadingDeemed' ||
            reading.readingType === 'EstimatedReading';
    });
    return readsToValidateAgainst.sort(utils_1.mostRecentFirst)[0];
};
exports.getLatestActualOrIndustryEstimateReading = getLatestActualOrIndustryEstimateReading;
//This reading is used by retailers to show the latest reading to the customer
//Different retailers want different reading types to be 'important' enough to display
//This reading is also used for frontend thresholdValidation if that is used
var getLatestImportantReading = function (readings) {
    return (0, reads_config_1.readsConfig)('prioritiseIndustryEstimates')
        ? (0, exports.getLatestActualOrIndustryEstimateReading)(readings)
        : (0, exports.getLatestActualReading)(readings);
};
exports.getLatestImportantReading = getLatestImportantReading;
